import { setup } from './model/setup'

export {
  useSaveDeeplink,
  useHasDeeplink,
  useRestoreDeeplink,
} from './lib/hooks'

export const $$deeplink = { setup }
